import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { ThumbsUp, Download , Eye} from "lucide-react";
import OTGToolbar from "./OTGToolBar";
import {toast, ToastContainer} from "react-toastify";
import { Mail } from 'lucide-react';
import {Tooltip} from "react-tooltip";
import AttendanceTabs from "./components/AttendanceTab";
import GPSCoordinateInput from "./components/GpsCoordinateInput";


const ViewEvent = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [kudosSent, setKudosSent] = useState(false);
    const [kudosSending, setKudosSending] = useState(false);
    const [goingList, setGoingList] = useState(null);
    const [waitingList, setWaitingList] = useState(null);
    const [currentUserId, setCurrentUserId] = useState(null);
    const [notgoingList, setNotGoingList] = useState(null);
    const [ searchTerm] = useState(location.state?.searchTerm || null);
    const [filters] = useState(location.state?.filters || {});

    const [isLeaving, setIsLeaving] = useState(false);


    useEffect(() => {
        const fetchEvent = async () => {
            try {
                setLoading(true);
                const response = await fetch(`/otgservices/getOTGEvents.php?id=${id}`);
                if (!response.ok) throw new Error("Failed to fetch event");
                const data = await response.json();
                if ( data.rows.length) {
                    setEvent(data.rows[0])

                    setGoingList(data.rows[0].goingList);
                    setWaitingList(data.rows[0].waitingList);
                    setNotGoingList(data.rows[0].notgoingList);
                    setCurrentUserId(data.rows[0].currentuserid);
                    setEvent(data.rows[0]);
                }
                else {
                    setError('The event was Not found');
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (id) fetchEvent();
    }, [id]);

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";

        const [year, month, day] = dateStr.split('-');
        return new Date(year, month - 1, day).toLocaleDateString('en-US', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };

    const handleEmailClick = async () => {
        navigate(`/events/sendEventUsersAnEmail/${event.id}`);
    }

    const handleViewRoute = async() => {
        if (!event.gpx_file_url) return;
        navigate(`/events/otggpx/${event.id}`);
    }

    const handleDownloadRoute = () => {
        if (!event.gpx_file_url) return;

        // Construct the download URL
        const downloadUrl = event.gpx_file_url;

        // Open in a new tab/window
        window.open(downloadUrl, '_blank');
    };

    const sendKudos = async () => {
        if (kudosSent || kudosSending) return;

        setKudosSending(true);
        try {
            const response = await fetch(`/otgservices/sendKudos.php?event_id=${id}`);

            if ( response.ok ) {
                const data = await response.json();

                if (data.status === "success") {
                    toast.success("Kudos sent successfully!");
                } else {
                    toast.error("Failed to send Kudos: " + (response.data.message || "Unknown error"));
                }

            }
            setKudosSent(true);
        } catch (err) {
            console.error("Error sending kudos:", err);
        } finally {
            setKudosSending(false);
        }
    };




    const handleLeave = async (event) => {
        const confirmed = window.confirm('Are you sure you want to leave this event?');
        if (!confirmed) {
            return;
        }
        setIsLeaving(true);

        try {
            const leaveresponse = await fetch('/otgservices/leaveEvent.php?&event_id='+event.id);

            const data = await leaveresponse.json();

            if (data.status === "success") {
                toast.success(" You have left the event successfully!");
                    try {
                        setLoading(true);
                        const response = await fetch(`/otgservices/getOTGEvents.php?id=` + event.id);
                        if (!response.ok) throw new Error("Failed to fetch event");
                        const data = await response.json();
                        if ( data.rows.length) {
                            setEvent(data.rows[0])

                            setGoingList(data.rows[0].goingList);
                            setWaitingList(data.rows[0].waitingList);
                            setNotGoingList(data.rows[0].notgoingList);
                            setCurrentUserId(data.rows[0].currentuserid);
                            setEvent(data.rows[0]);
                        }
                        else {
                            setError('The event was Not found');
                        }
                    } catch (err) {
                        setError(err.message);
                    } finally {
                        setLoading(false);
                        setIsLeaving(false);
                    }
            } else {
                toast.error("Failed to Leave event: " + (data.message || "Unknown error"));
                setIsLeaving(false);

            }
        } catch (error) {
            toast.error("Error Leaving event. Please try again.");
            console.error(error);
            setIsLeaving(false);
        }
    }

    const handlePrivateJoin = async () => {

        if ( currentUserId === null || ( currentUserId === "" || currentUserId.length === 0) ) {
            toast.error("You need to be logged in! Please go to www.overlandtrailguides.com");
            return;
        }

        const eventType = event.eventtype;

        // If admin has sus-ended subscriptions do NOT check for subscriptions
        if ( event.suspendsubs) {
            if (eventType === "Meetup" || eventType.includes("Volunteer")) {
                navigate(`/events/sm-join-event/${event.id}/${currentUserId}`, {state: {event : event, userId : currentUserId}});
            } else {
                navigate(`/events/join-event/${event.id}/${currentUserId}`, {state: {event, userId : currentUserId}});
            }
            return;
        }


        fetch('/otgservices/checkSubscription.php')
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(json => {
                if (!eventType.includes("BaseCamp")) {
                    if (!json.success) {
                        toast.error("You must have a subscription to Join. Please go to www.overlandtrailguides.com and subscribe");
                        return;
                    }
                }
                if (eventType === "Meetup" || eventType.includes("Volunteer")) {
                    navigate(`/events/sm-join-event/${event.id}/${currentUserId}`, {state: {event : event, userId : currentUserId}});
                } else {
                    navigate(`/events/join-event/${event.id}/${currentUserId}`, {state: {event, userId : currentUserId}});
                }
            })
            .catch(error => {
                console.error('Error checking subscription:', error);
                toast.error("Error checking subscription status. Please try again.");
            });

    };


    const openForum = (url) => {
        window.open(url, '_blank').focus();
    }

    const handleAttendeeChange = (userId, sourceList, action, targetList = null) => {
        // Clone the current event object
        const updatedEvent = JSON.parse(JSON.stringify(event));

        // Safety check before operations
        if (!updatedEvent[`${sourceList}List`]) {
            updatedEvent[`${sourceList}List`] = [];
        }

        if (action === 'delete') {
            // Remove from the source list
            updatedEvent[`${sourceList}List`] = updatedEvent[`${sourceList}List`].filter(
                attendee => attendee.user_id !== userId
            );
        } else if (action === 'move' && targetList) {
            // Ensure target list exists
            if (!updatedEvent[`${targetList}List`]) {
                updatedEvent[`${targetList}List`] = [];
            }

            // Find the attendee in source list
            const attendeeIndex = updatedEvent[`${sourceList}List`].findIndex(a => a.user_id === userId);

            if (attendeeIndex !== -1) {
                // Get the attendee
                const attendee = updatedEvent[`${sourceList}List`][attendeeIndex];

                // Remove from source list
                updatedEvent[`${sourceList}List`] = updatedEvent[`${sourceList}List`].filter(
                    attendee => attendee.user_id !== userId
                );

                // Add to target list
                updatedEvent[`${targetList}List`].push(attendee);
            }
        }


        // Update the event state
        setEvent(updatedEvent);
        setGoingList(updatedEvent.goingList);
        setWaitingList(updatedEvent.waitingList);
        setNotGoingList(updatedEvent.notgoingList);
    };

    if (loading) return <div className="p-6 text-center">Loading event...</div>;
    if (error) return <div className="p-6 text-center text-red-500">Error: {error}</div>;
    if (!event) return <div className="p-6 text-center">Event not found.</div>;

    return (
        <div className="p-6 bg-gray-100 min-h-screen">
            <ToastContainer/>
            <OTGToolbar/>
            <div className="max-w-4xl mx-auto">
                <h2 className="text-2xl font-bold mb-4 py-2 text-center">View Event</h2>

                <div className="bg-white p-6 rounded shadow">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        {/* Left Column */}
                        <div className="space-y-4">
                            <Field label="Event Name" value={event.name}/>
                            {!event.hide_dates && (
                            <div className="grid grid-cols-2 md:grid-cols-2">
                                <Field label="Start Date" value={formatDate(event.start_time)}/>
                                <Field label="End Date" value={formatDate(event.end_time)}/>
                            </div>
                            )}
                            {!event.hide_dates && (
                            <div className="grid grid-cols-2 md:grid-cols-2">
                                <Field label="Start Time" value={event.begin_hour_time}/>
                                <Field label="End Time" value={event.end_hour_time}/>
                            </div>
                            )}

                            <Field label="Event Summary" value={event.summary} multiline/>
                            {/* Show image preview if available */}
                            {/* Image preview with centered display */}
                            {event.imageurl && (
                                <div className="mt-4">
                                    <div
                                        className="w-full bg-gray-100 rounded border border-gray-300 overflow-hidden flex justify-center items-center"
                                        style={{minHeight: "200px"}}>
                                        <img
                                            src={event.imageurl}
                                            alt="Event"
                                            className="max-w-full max-h-96 object-contain"
                                            style={{imageRendering: 'high-quality'}}
                                        />
                                    </div>
                                </div>
                            )}
                            <div className="flex flex-wrap gap-4 p-2 border border-gray-300 rounded bg-gray-100">
                                <span>Children: <strong>{event.children_permitted ? "Yes" : "No"}</strong></span>
                                <span>Dogs: <strong>{event.dogs_permitted ? "Yes" : "No"}</strong></span>
                                <span>Public: <strong>{event.is_public ? "Yes" : "No"}</strong></span>
                            </div>
                        </div>

                        {/* Right Column */}
                        <div className="space-y-4">

                            <div className="grid grid-cols-2 md:grid-cols-2">
                                <Field label="Region" value={event.region}/>
                                <Field label="State/Prov" value={event.location}/>
                            </div>


                            {!event.revenueevent && (
                                <div>
                                    <Field label="Event Type" value={event.eventtype}/>
                                    <Field label="Terrain" value={event.terrain}/>
                                    <Field label="Recommended Vehicle" value={event.recommended_vehicle}/>
                                    <Field label="Required Gear" value={event.required_gear}/>


                                </div>
                            )}

                            {!event.revenueevent && (
                                <div>
                                    <div className="grid grid-cols-2 md:grid-cols-2 gap-4">
                                        <Field label="Comms" value={event.comms}/>
                                        <Field label="Channel" value={event.channel}/>
                                    </div>


                                    <div className="grid grid-cols-2 md:grid-cols-2 gap-4">
                                        <Field label="Max Rigs" value={event.max_rigs}/>
                                        <Field label="Technical Rating" value={event.technical_rating}/>
                                    </div>
                                </div>
                            )}

                            <Field label="Meeting Instructions" value={event.meetup_location}/>
                            {event.gpscoordinate && (
                                <div>
                                    <Field label="Meeting Location" value={event.meetaddress}/>
                                    <div>
                                        <GPSCoordinateInput
                                            value={event.gpscoordinate}
                                            className="w-full"
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )
                            }

                            {!event.revenueevent && (
                                <div>
                                    <div className="grid grid-cols-2 md:grid-cols-2 gap-4">
                                        <Field label="Co Host 1" value={event.cohost1UserName}/>
                                        <Field label="Co Host 2" value={event.cohost2UserName}/>
                                    </div>
                                    {/* Avatar row */}
                                    <div className="grid grid-cols-2 gap-4 mt-0">
                                        <div className="flex justify-center">
                                            {event.cohost1avatar ? (
                                                <img
                                                    src={event.cohost1avatar}
                                                    alt="Co Host 1 Avatar"
                                                    className="w-12 h-12 rounded-full object-cover border-2 border-gray-300"
                                                />
                                            ) : (
                                                <div
                                                    className="w-12 h-12 rounded-full bg-gray-200 border-2 border-gray-300"></div>
                                            )}
                                        </div>
                                        <div className="flex justify-center">
                                            {event.cohost2avatar ? (
                                                <img
                                                    src={event.cohost2avatar}
                                                    alt="Co Host 2 Avatar"
                                                    className="w-12 h-12 rounded-full object-cover border-2 border-gray-300"
                                                />
                                            ) : (
                                                <div
                                                    className="w-12 h-12 rounded-full bg-gray-200 border-2 border-gray-300"></div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {(event.gpx_file_url && event.currentuserid && !event.revenueevent) && (
                                <div className="flex flex-col gap-2">
                                    <div>
                                        <button
                                            onClick={handleDownloadRoute}
                                            id="download-route-btn"
                                            className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors w-full justify-center"
                                        >
                                            <Download size={18}/>
                                            <span>Download Route</span>
                                        </button>
                                        <Tooltip
                                            anchorSelect="#download-route-btn"
                                            place="top"
                                            content="Download the GPX route file"
                                        />
                                    </div>
                                    <div>
                                        <button
                                            onClick={handleViewRoute}
                                            id="view-route-btn"
                                            className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors w-full justify-center"
                                        >
                                            <Eye size={18}/>
                                            <span>View Route</span>
                                        </button>
                                        <Tooltip
                                            anchorSelect="#view-route-btn"
                                            place="top"
                                            content="ViewGPX route file"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>

                    {/* Attendance */}
                    {/*}
                    <div className="mt-8 pt-6 border-t border-gray-300">
                        <h3 className="text-lg font-semibold mb-4">Attendance</h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <Field label="Going" value={event.going} multiline/>
                            <Field label="Waiting" value={event.waiting} multiline/>
                        </div>
                    </div>
                    */}
                    {!event.revenueevent && (
                        <div className="mt-6">
                            {/* Button container with proper spacing */}
                            <div className="flex items-center justify-between flex-wrap gap-4">

                                {/* Left side buttons */}
                                <div className="flex items-center gap-4">
                                    {event.editable && (
                                        <span id="email-tt">
                                            <button
                                                onClick={handleEmailClick}
                                                className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors"
                                                aria-label="Send Email"
                                            >
                                                <Mail size={18}/>
                                                <span>Mail All</span>
                                            </button>
                                            <Tooltip
                                                anchorSelect="#email-tt"
                                                place="top"
                                                content="Email all participants in event"
                                            />
                                        </span>
                                    )}

                                    {(event.forumurl && event.isgoing) && (
                                        <span id="forum-tt">
                                            <button
                                                type="button"
                                                onClick={() => openForum(event.forumurl)}
                                                className="flex items-center gap-2 bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600"
                                            >
                                                <span>Forum</span>
                                            </button>
                                            <Tooltip
                                                anchorSelect="#forum-tt"
                                                place="top"
                                                content="Open event forum"
                                            />
                                        </span>

                                    )}
                                </div>

                                {/* Center buttons */}
                                <div className="flex items-center gap-4">
                                    <button
                                        onClick={() => {
                                            const lroute = '/events/#event-' + event.id;
                                            navigate(lroute, {
                                                state: {
                                                    action   : 'refresh',
                                                    timestamp: Date.now(),
                                                    searchTerm : searchTerm,
                                                    filters : filters
                                                }
                                            })
                                        }}
                                        className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                                    >
                                        Back
                                    </button>
                                </div>

                                {/* Right side button */}
                                <div className="flex items-center">
                                        <span id="kudos-tt">
                                            <button
                                                onClick={sendKudos}
                                                disabled={kudosSent || kudosSending}
                                                className={`flex items-center gap-2 rounded px-4 py-2 ${
                                                    kudosSent
                                                        ? "bg-green-100 text-green-700 cursor-default"
                                                        : kudosSending
                                                            ? "bg-blue-100 text-blue-600 cursor-wait"
                                                            : "bg-blue-600 text-white hover:bg-blue-700"
                                                }`}
                                            >
                                                <ThumbsUp size={18}/>
                                                <span>{kudosSent ? "Kudos Sent!" : kudosSending ? "Sending..." : "Kudos"}</span>
                                            </button>
                                            <Tooltip
                                                anchorSelect="#kudos-tt"
                                                place="top"
                                                content="Send Kudos to Event Leader"
                                            />
                                        </span>
                                </div>
                            </div>
                        </div>

                    )}
                </div>
            </div>

            {(!event.isgoing && !event.blocked && event.open_for_registration != 0) && (
                <div className="flex items-center justify-center gap-4 py-4">
                    <span id="join-view-event-tt">
                                        <button
                                            onClick={handlePrivateJoin}
                                            className="bg-green-600 text-white px-4 py-4 rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 transition-colors"
                                        >
                                                    Join this event
                                                </button>
                                                <Tooltip
                                                    anchorSelect="#join-view-event-tt"
                                                    place="top"
                                                    content="Join this event"
                                                />
                                         </span>

                </div>
            )}

            {(event.isgoing) && (
                <div className="flex items-center justify-center gap-4 py-4">
                    <span id="leave-view-event-tt">
                                        <button
                                            onClick={() => {
                                                handleLeave(event);
                                            }}
                                            disabled={isLeaving}
                                            className="bg-gray-500 text-white px-4 py-4 rounded hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-grey-800 focus:ring-opacity-50 transition-colors"
                                        >
                                                   {isLeaving ? 'Leaving...' : 'Leave this Event'}
                                                </button>
                                                <Tooltip
                                                    anchorSelect="#leave-view-event-tt"
                                                    place="top"
                                                    content="Leave this event"
                                                />
                                         </span>

                </div>
            )}



            {event.revenueevent && (
                <div className="flex items-center justify-center gap-4 py-4">
                    <button
                        onClick={() => {
                            const lroute = '/events/#event-' + event.id;
                            navigate(lroute, {
                                state: {
                                    action   : 'refresh',
                                    timestamp: Date.now()
                                }
                            })
                        }}
                        className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                    >
                        Back
                    </button>

                    <button
                        onClick={() => {
                            alert("Go to the Special Page");
                        }}
                        className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600"
                    >
                        Event Details
                    </button>

                    {(!event.is_public && !event.isgoing && event.open_for_registration != 0) && (
                        <span id="join-private-event-tt">
                        <button
                            onClick={handlePrivateJoin}
                            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 transition-colors">
                            Join
                        </button>
                        <Tooltip
                            anchorSelect="#join-private-event-tt"
                            place="top"
                            content="Join this private event"
                        />
                        <   /span>
                    )}


                        </div>
            )}



            {!event.revenueevent && (
                <div className="max-w-4xl mx-auto mt-8">
                    <h2 className="text-xl font-bold mb-4 text-center">Event Attendance</h2>
                    <AttendanceTabs goingList={goingList} waitingList={waitingList} notgoingList={notgoingList}
                                    editable={event.editable}
                                    currentUserId={currentUserId} event={event}
                                    onAttendeeChange={handleAttendeeChange}/>
                </div>)}
        </div>
    );
};

const Field = ({label, value, multiline = false}) => {
    // Custom styling for technical rating field
    let customStyle = {};

    if (label === "Technical Rating" && value !== null && value !== undefined) {
        const rating = parseInt(value);
        if (!isNaN(rating)) {
            if (rating < 4) {
                customStyle = {backgroundColor: '#07a554', textAlign: 'center'};
            } else if (rating >= 4 && rating <= 7) {
                customStyle = {backgroundColor: '#2265bd', textAlign: 'center'};
            } else if (rating >= 8) {
                customStyle = {backgroundColor: '#1f2937', color: 'white', textAlign: 'center'};
            }
        }
    }

    if (label === "Event Summary") {
        customStyle = {
            border: '1px solid #e5e7eb', // Small light gray border
            margin: '0'
            //padding: '0'
        };
    }

    return (
        <div>
            <label className="block mb-1 text-sm font-bold">{label}</label>
            <div
                className={`px-1 py-1 rounded ${multiline ? "min-h-20" : ""}`}
                style={customStyle}
            >
                {value || ""}
            </div>
        </div>
    );
};

export default ViewEvent;